
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { resetAlreadyExists, setViewStartConversationModal } from '../../../features/messenger/conversationSlice'
import styled from 'styled-components'
import AddIcon from '@mui/icons-material/Add';
import { pBtn } from 'components/main.styled';
import { IoCreateOutline } from "react-icons/io5";
import { useTranslation } from 'react-i18next'

function NewConversationBtn() {
    const { t } = useTranslation('messaging')
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { alreadyExists } = useSelector(state => state.conversations)

    const handleClick = async () => {

        if(alreadyExists){
            dispatch(resetAlreadyExists())
        }

        // navigate('/messages/new', {replace: true}  )
        dispatch(setViewStartConversationModal(true))

    }

    return ( 
        <StartNewContainer onClick={handleClick}> 
            <IoCreateOutline size={16} /> 
            <p>{t('newMessage')}</p>
        </StartNewContainer>
    )
}

export default NewConversationBtn

const StartNewContainer = styled(pBtn)` 
    background-color: rgb(255, 255, 255);  
    border: 2px solid var(--themeColor);
    color: var(--themeColor);
    height: 35px;
    
    p{
        font-size: 13px;
    }

    &:hover{ 
        background-color: var(--themeColor);
        color: white; 
    }
    @media (max-width: 768px) {
        width: fit-content;
        font-size: smaller; 
    }
`
